<template>
  <v-card :loading="loading">
    <v-card-title class="subtitle-2">
      Conversion chart (without pirates)
    </v-card-title>
    <v-card-text v-if="!show || loading" height="350" class="pa-2 caption black--text">
      <v-sheet height="350" class="d-flex justify-center align-center">
        <v-btn
          color="primary"
          :loading="loading"
          @click="show = true"
        >
          Load data
        </v-btn>
      </v-sheet>
    </v-card-text>
    <v-card-text v-else class="pa-2 caption black--text">
      <v-select
        v-model="selectedMap"
        :items="maps"
        label="Select map"
        hide-details
        outlined
        dense
        @change="updateSelectedEncounters"
      />
      <apexchart
        :key="chartKey"
        type="bar"
        :height="350"
        :options="chartOptions"
        :series="filteredSeries"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      loading: false,
      show: false,
      selectedMap: "All",
      encounters: [],
      selectedEncounters: [],
      maps: [],
      series: [
        {
          data: []
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: false,
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top'
            },
          },
        },
        dataLabels: {
          enabled: false,
          formatter: function (val) {
            return (val || 0).toFixed(2) + '%'
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            formatter: (value) => `${value}%`
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return (val || 0).toFixed(2) + '%'
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        }
      }
    }
  },
  watch: {
    async '$route.params' () {
      if (this.show) {
        await this.getData()
      }
    },
    async show (val) {
      if (val) {
        await Promise.all([
          this.getData(),
          this.getEncounters()
        ])
      }
    }
  },
  computed: {
    filteredSeries () {
      if (!this.selectedEncounters.length) {
        return this.series
      }

      const selected = this.selectedEncounters.map(String)

      return this.series.map(series => ({
        ...series,
        data: series.data.filter(item =>
          selected.includes(String(item.x)) || item.x === 'Complete' || item.x === 'Add to Wishlist'
        )
      }))
    },
    chartKey () {
      return this.selectedEncounters
        .map(String)
        .sort()
        .join('|')
    },
  },
  methods: {
    async getEncounters () {
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/configs/telemetry/encounters`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.encounters = data
        this.selectedEncounters = data.map(encounter => encounter.name)
        this.maps = Array.from(new Set([ 'All', ...data.map(map => map.map_name) ]))
      }
    },
    updateSelectedEncounters (val) {
      if (val === "All") {
        this.selectedEncounters = this.encounters.map(encounter => encounter.name)
      } else {
        this.selectedEncounters = this.encounters
          .filter(encounter => encounter.map_name === val)
          .map(encounter => encounter.name)
      }

      this.chartOptions = {
        ...this.chartOptions,
        dataLabels: {
          ...this.chartOptions.dataLabels,
          enabled: val !== "All"
        }
      }
    },
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/tension-beats`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.series = data.series
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
  .align-top {
    vertical-align: top;
  }
</style>